// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"e49db647","370":"4f648d51","766":"b45bcea4","892":"e26b7a93","987":"96f19056"}[chunkId] + ".chunk.js";
};